import React from "react";
import Modal from "../../../components/ui/Modal/Modal";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import { HiMagnifyingGlass } from "react-icons/hi2";
import Button from "../../../components/ui/Button/Button";
import AdminContactTable from "./AdminContactTable";
import {
  fetchAdminContacts,
  useAdminContacts,
} from "../../../api/admin-contact/use-admin-contact";

const options = [
  { id: "name", name: "성명" },
  { id: "affiliation", name: "소속" },
  { id: "phone", name: "휴대전화 번호" },
];

const SelectRecipient = ({ setContact, setTriggerCloseModal, contact }) => {
  const [searchBy, setSearchBy] = React.useState("name");
  const [searchValue, setSearchValue] = React.useState("");
  const { data: contactList } = useAdminContacts(false, searchBy, searchValue);
  const [contactListData, setContactListData] = React.useState(
    contactList?.data
  );
  const [selectedContact, setSelectedContact] = React.useState([]);
  const [selectedBindedContact, setSelectedBindedContact] =
    React.useState(contact);
  const [notFoundPopup, setNotFoundPopup] = React.useState(false);
  const handleSelectContact = (id) => {
    const index = selectedContact.indexOf(id);

    if (!selectedContact.includes(id)) {
      setSelectedContact([...selectedContact, id]);
    }
    if (index > -1) {
      selectedContact.splice(index, 1);
      setSelectedContact([...selectedContact]);
    }
  };
  const handleSelectBindedContact = (id) => {
    const index = selectedBindedContact.indexOf(id);

    if (!selectedBindedContact.includes(id)) {
      setSelectedBindedContact([...selectedBindedContact, id]);
    }
    if (index > -1) {
      selectedBindedContact.splice(index, 1);
      setSelectedBindedContact([...selectedBindedContact]);
    }
  };

  const handleBindContacts = async () => {
    const binded = contactList?.data
      ?.filter((val) => selectedContact?.includes(val?.id))
      .map((res) => res);
    setSelectedBindedContact([...selectedBindedContact, ...binded]);
    // setMemberListData(
    //   memberListData
    //     ?.filter((res) => !selectedMember?.includes(res?.id))
    //     .map((res) => res)
    // );
    setSelectedContact([]);
  };

  const handleDeleteBindedContact = async (id) => {
    const deleted = selectedBindedContact
      ?.filter((val) => val?.id !== id)
      ?.map((res) => res);
    setSelectedBindedContact(deleted);
    // memberListData.push(deleted);
  };

  const handleDeleteAllBindedContact = async () => {
    setSelectedBindedContact([]);
    setContactListData(contactList?.data);
  };

  const onSubmitBindContact = () => {
    setContact(selectedBindedContact);
    setTriggerCloseModal(true);
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const res = await fetchAdminContacts(false, searchBy, searchValue);
    setContactListData(res?.data);
    if (res?.data?.length === 0) {
      setNotFoundPopup(true);
    }
  };

  const handleResetSearch = async () => {
    const res = await fetchAdminContacts(false);
    setContactListData(res?.data);
    setSearchValue("");
  };

  return (
    <div>
      <div className="px-6">
        <p>1. 관리자 연락처 목록</p>
        <div className="flex mt-2 -mr-2 justify-between">
          <Dropdown
            width="w-32"
            options={options}
            height="h-10"
            positionDropdown={`top-12`}
            placeholder="성명"
            textColor="text-black px-4"
            onClickItem={(id) => setSearchBy(id)}
          />
          <form className="flex" onSubmit={handleSearch}>
            <input
              type="search"
              className={`w-[230px] text-black border-l border-t border-b border-button-grey rounded-l-[4px] p-2 focus:outline-0`}
              placeholder="수신할 관리자 정보 입력 후, 검색"
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
            <button
              type="submit"
              className="cursor-pointer flex items-center bg-[#19459f] px-4 py-2 border-r border-[#19459f] rounded-r-[4px]"
            >
              <HiMagnifyingGlass className="text-white text-[18px] m-auto" />
            </button>
          </form>

          <Button
            onClick={handleResetSearch}
            text="검색결과 초기화"
            borderColor="border-[#cccccc] border"
          />
        </div>
        <AdminContactTable
          selectedContact={selectedContact}
          handleSelectContact={handleSelectContact}
          contactList={contactListData}
        />
        <div className="mt-4 w-full">
          <Button
            onClick={handleBindContacts}
            width="w-full"
            text={`수신 대상자 추가 +`}
            borderColor="border border-primary-blue"
            bgColor="bg-primary-blue"
            textColorDefault="text-white"
            disabledTextColor="text-white"
          />
        </div>

        <p className="mt-6">2. 수신 대상자 목록</p>

        <AdminContactTable
          isBinded={true}
          contactList={selectedBindedContact}
          isCheckbox={false}
          handleSelectContact={handleSelectBindedContact}
          handleDeleteBindedContact={handleDeleteBindedContact}
        />

        <div className="flex text-[11px] justify-between mt-2">
          <p>
            ※ 수신 대상자로 지정할 정보 선택 후, [수신 대상자 추가+]를 눌러
            <br />
            추가한 후 [선택완료]를 눌러주세요.
          </p>

          <Modal
            onSubmit={handleDeleteAllBindedContact}
            description={
              <div>
                수신 대상자로 추가된 명단을 전체 삭제하시겠습니까?
                <br />
                전체 삭제할 경우, 상단 리스트에서 체크된 정보가 초기화 됩니다.
              </div>
            }
          >
            <Button
              width="w-[10rem]"
              disabledTextColor="text-white"
              text={`수신 대상자 추가 - 전체삭제`}
              margin="mr-0"
              paddingButton="p-[4px]"
              isDisabled={selectedBindedContact.length === 0}
            />
          </Modal>
        </div>
        <div className="mt-4">
          <Button
            onClick={onSubmitBindContact}
            borderColor="border border-primary-blue"
            bgColor="bg-primary-blue"
            textColorDefault="text-white"
            width="w-full"
            className={`text-sm`}
            text={`선택완료`}
            disabledTextColor="text-white"
            isDisabled={selectedBindedContact.length === 0}
            margin="mr-0"
            paddingButton="py-3"
          />
        </div>
      </div>
      {notFoundPopup && (
        <Modal
          isOpenFromOutside={notFoundPopup}
          setIsOpenFromOutside={setNotFoundPopup}
          description="검색 결과가 없습니다."
          hasCancel={false}
        />
      )}
    </div>
  );
};

export default SelectRecipient;
